import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import enTranslation from "./locales/en/translation.json"; //english
import hiTranslation from "./locales/hi/translation.json"; //hindi
import esTranslation from "./locales/es/translation.json"; //spanish
import frTranslation from "./locales/fr/translation.json"; //french
import jaTranslation from "./locales/ja/translation.json"; //japannese
import arTranslation from "./locales/ar/translation.json"; //arabic
import ruTranslation from "./locales/ru/translation.json"; //russian
import ptTranslation from "./locales/pt/translation.json"; //portugese
import idTranslation from "./locales/id/translation.json"; //Indoasia
import faTranslation from "./locales/fa/translation.json"; //Persian
import trTranslation from "./locales/tr/translation.json"; //Turkish
import koTranslation from "./locales/ko/translation.json"; //Korean
import deTranslation from "./locales/de/translation.json"; //Germanms
import itTranslation from "./locales/it/translation.json"; //italian
import ukTranslation from "./locales/uk/translation.json"; //ukraine
import nlTranslation from "./locales/nl/translation.json"; //netherlands
import thTranslation from "./locales/th/translation.json"; //thai
import viTranslation from "./locales/vi/translation.json"; //vietnamese
import fiTranslation from "./locales/fi/translation.json"; //finnish
import zhTranslation from "./locales/zh/translation.json"; //chinese
import csTranslation from "./locales/cs/translation.json"; //Czech
import msTranslation from "./locales/ms/translation.json"; //malay
import tlTranslation from "./locales/tl/translation.json"; //Filipino
import urTranslation from "./locales/ur/translation.json"; //Urdu
import daTranslation from "./locales/da/translation.json"; //Danish
import gbTranslation from "./locales/en-GB/translation.json"; //British
import usTranslation from "./locales/en-US/translation.json"; //American

const resources = {
  en: {
    translation: enTranslation,
  },
  hi: {
    translation: hiTranslation,
  },
  es: {
    translation: esTranslation,
  },
  fr: {
    translation: frTranslation,
  },
  ja: {
    translation: jaTranslation,
  },
  ar: {
    translation: arTranslation,
  },
  ru: {
    translation: ruTranslation,
  },
  pt: {
    translation: ptTranslation,
  },
  id: {
    translation: idTranslation,
  },
  fa: {
    translation: faTranslation,
  },
  tr: {
    translation: trTranslation,
  },
  ko: {
    translation: koTranslation,
  },
  de: {
    translation: deTranslation,
  },
  it: {
    translation: itTranslation,
  },
  uk: {
    translation: ukTranslation,
  },
  nl: {
    translation: nlTranslation,
  },
  th: {
    translation: thTranslation,
  },
  vi: {
    translation: viTranslation,
  },
  fi: {
    translation: fiTranslation,
  },
  zh: {
    translation: zhTranslation,
  },
  cs: {
    translation: csTranslation,
  },
  ms: {
    translation: msTranslation,
  },
  tl: {
    translation: tlTranslation,
  },

  ur: {
    translation: urTranslation,
  },
  da: {
    translation: daTranslation,
  },
  "en-GB": { translation: gbTranslation },
  "en-US": { translation: usTranslation },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: "en",
    detection: {
      order: ["localStorage", "navigator"],
      caches: ["localStorage"],
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
